module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Help2.66836e0f.svg";